import React from "react";
import { LockIcon, ShieldCheckIcon, SmartphoneIcon } from "lucide-react";
export function Footer() {
  return <footer className="w-full border-t border-[#eef2f6] bg-white px-5 py-12 sm:px-8" data-id="element-93" data-mp="3gg11ma61ua0t">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-6 text-center" data-id="element-94" data-mp="32ovwisjwwpj3">
        <p className="font-serif-display text-lg text-[var(--ink)]" data-id="element-95" data-mp="36oo87e4lrbso">
          Pequeños Pasos, Grandes Logros™
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-[var(--muted)]" data-id="element-96" data-mp="3ugbqx8rpngjv">
          <span className="flex items-center gap-1.5" data-id="element-97" data-mp="387fpncvpdfs">
            <LockIcon className="h-4 w-4 text-[var(--accent)]" aria-hidden data-id="element-98" data-mp="3levhp4cmtkh8" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-99" data-mp="3qcnkwuiq8t0q">
            <ShieldCheckIcon className="h-4 w-4 text-[var(--accent)]" aria-hidden data-id="element-100" data-mp="3qfjey7rgexjw" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-101" data-mp="2eya0y0r3gxpz">
            <SmartphoneIcon className="h-4 w-4 text-[var(--accent)]" aria-hidden data-id="element-102" data-mp="2ezuvhqdesgnu" /> Celular, tablet y PC
          </span>
        </div>
        <p className="text-xs text-[var(--muted)]" data-id="element-103" data-mp="3lbdc0r0ka5kr">
          © {new Date().getFullYear()} Pequeños Pasos, Grandes Logros. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}